export default {
    AADI: require('./AADI_logo@2x.png'),
    ADC: require('./ADC_logo@2x.png'),
    ARCUTIS: require('./Arcutis_logo@2x.png'),
    ASCENDIS: require('./Ascendis_logo@2x.png'),
    EPIZYME: require('./Epizyme_logo@2x.png'),
    ESPERION: require('./Esperion_logo@2x.png'),
    EVERSANA: require('./EVERSANA_logo@2x.png'),
    HERON: require('./Heron_logo@2x.png'),
    KINIKSA: require('./Kiniksa_logo@2x.png'),
    MYOVANT: require('./Myovant_logo@2x.png'),
    NEURELIS: require('./Neurelis_logo@2x.png'),
    OMEROS: require('./Omeros_logo@2x.png'),
    REGENERON: require('./Regeneron_logo@2x.png'),
    ITM: require('./ITM.png'),
};